import React from "react";
import { DataGrid, GridToolbarContainer, GridToolbarExport, gridClasses } from '@mui/x-data-grid';
import { I18nPropvider } from './../../i18nProvider';

function getInfoSatellite(props) {

  props.onChangeValue(props.data); 


}

export function TableauSatellite({satellite, columns,onChangeValue}) {

    
    return (
      <I18nPropvider >
        <div id="tableauSatellite" className="bg-white" style={{ height: 400, width: '100%' }}>
          <DataGrid rows={satellite} columns={columns}  
           
          onRowClick={(data) => { getInfoSatellite({data, onChangeValue }) }}    
                     />
        </div>
      </I18nPropvider>
  
    );
  }
  export default TableauSatellite;

 